<mat-card class="login-card">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'auth.forgotPassword.fullLabel' | translate}}
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form *ngIf="!resetPasswordSent"
            [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <div class="reset-field">
                <mat-form-field>
                    <mat-icon matPrefix>person</mat-icon>
                    <mat-label>{{'auth.login.username.label.shortLabel' | translate}}</mat-label>
                    <input type="text" inputmode="email" matInput formControlName="username">
                    <mat-error>{{'auth.login.username.errorMessage.summary' | translate}}</mat-error>
                </mat-form-field>
            </div>

            <button *ngIf="!isLoading"
                type="submit" mat-raised-button color="accent"
                [disabled]="resetForm.invalid || isLoading">{{'auth.submit.shortLabel' | translate}}</button>
            <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
        </form>
        <div *ngIf="resetPasswordSent">
            <p>{{'auth.changePassword.email.summary' | translate}}</p>
        </div>
    </mat-card-content>
</mat-card>
